module.exports = __webpack_public_path__ + "img/ico-logout-default.5c3107eb.svg";